export const SCHEDULE_VISIO_URL = "https://cal.com/simon-boisset/meet-simon";
export const GITHUB_URL = "https://github.com/simonboisset";
export const LINKEDIN_URL = "https://www.linkedin.com/in/simon-boisset";
export const CONTACT_EMAIL = "simon@lezo.dev";
export const CV_PDF_URL = "/cv/Simon-Boisset-CV.pdf";
